module.exports = __webpack_public_path__ + "img/emoji_101.e55d3dfe.png";